<template>
  <div
    key="video-panel"
    class="bg-black flex justify-center items-center"
    :style="isBigScreen ? 'height: calc(100vh - 180px);':''"
  >
    <div class="video-player">
      <video ref="videoPlayer" class="video-js" controls></video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
// import '@videojs/http-streaming';
import {stageParser, /*getRStage, getECode*/} from "@/utils/auth-data";
import {config} from "@/utils/upload";

export default {
  name: "MainPanelVdo",
  props: [
    'currentVdoSetTopic',
    'studentEnrollDetail',
    'keepCounting',
    'countLearningPercent',
    'isBigScreen',
    'forceStopVideo',
  ],
  data() {
    return {
      player: null,
      videoMimeType: "application/x-mpegURL",
      isPlaying: false,
      counter: 0,
      timer: null,
      e_code: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code,
      r_stage: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage,
    }
  },
  watch: {
    currentVdoSetTopic(val) {
      if (this.player) {
        this.changeVideoSrc(val);
      } else {
        if (this.currentVdoSetTopic) {
          this.setUpVideoJs(this.currentVdoSetTopic);

          if (this.player) {
            this.playVideoFromLastPosition();
          }
        }
      }
    },
    isPlaying(val){
      if(val){
        this.startTimer();
      }else{
        this.stopTimer();
      }
    },
    keepCounting(val){
      if(!val){
        this.stopTimer();
      }
    },
    forceStopVideo(val){
      if(val){
        this.player.dispose();
      }
    }
  },
  methods: {
    setUpVideoJs() {
      const _this = this;

      _this.player = videojs(this.$refs.videoPlayer, {
        sources: this.generateVdoSource(this.currentVdoSetTopic),
        controlBar: {
          playbackRateMenuButton: true,
          pictureInPictureToggle: false,
        },
        autoplay: true,
        fluid: false,
        controls: true,
        hotkeys: true,
        responsive: true,
        aspectRatio: '16:9',
        playbackRates: [1, 1.5, 2],
        preload: 'metadata',
        nativeControlsForTouch: true,
        nativeControls: true,

      }, function onPlayerReady() {
        _this.$refs.videoPlayer.controls = true;

        // wait for video metadata to load, then set time
        _this.player.on('loadedmetadata', function() {
          // _this.setStartPositionWhenSetUp();

          let lastPosition = _this.getLastPosition();
          //if last play is end then start from beginning
          if (lastPosition === parseInt(_this.player.duration())) {
            lastPosition = 0;
          }

          _this.player.currentTime(lastPosition);
        });

        let initdone = false;
        // iPhone/iPad need to play first, then set the time
        // events: https://www.w3.org/TR/html5/embedded-content-0.html#mediaevents
        _this.player.on('canplaythrough', function() {
          if (!initdone) {
            _this.setStartPositionWhenSetUp();
            initdone = true;
          }
        });

        _this.player.on('timeupdate', async function () {
          _this.saveLastPosition(_this.player.currentTime());
        });

        // Work when video is playing
        _this.player.on('playing', function () {
          _this.isPlaying = true;
        });

        //when video are pause trigger time update
        // not good event to save
        _this.player.on(['waiting', 'pause'], async function () {
          // console.log('video waiting,pause');
          _this.isPlaying = false;
          _this.saveLastPosition(_this.player.currentTime());
        });

        //when video end save progress and go to next episode
        _this.player.on('ended', async function () {
          // console.log('video ended');
          _this.isPlaying = false;
        });

      });
    },
    generateVdoSource(currentVdoSetTopic) {
      return [
        {
          src: this.getVideoSrc(currentVdoSetTopic),
          type: this.videoMimeType,
        }
      ]
    },
    getVideoSrc(currentVdoSetTopic) {
      // console.log('getECode',getECode());
      // console.log('getRStage',getRStage());
      // const STREAMING_APP = `${getECode()}_${stageParser(getRStage())}_vod`;
      const STREAMING_APP = `${this.e_code}_${stageParser(this.r_stage)}_vod`;
      const vdoStreamPath = currentVdoSetTopic ? currentVdoSetTopic.vdoStreamPath : '';
      return `${config.streamServer}/definst/${STREAMING_APP}/mp4:${vdoStreamPath}/playlist.m3u8`;
    },
    changeVideoSrc(currentVdoSetTopic) {
      //change video
      if (currentVdoSetTopic) {
        this.player.src(
          {
            src: this.getVideoSrc(currentVdoSetTopic),
            type: this.videoMimeType,
          },
        );

        this.playVideoFromLastPosition();
      }
    },
    playVideoFromLastPosition() {
      //auto play video when change
      const _this = this;
      setTimeout(function () {
        if (_this.player) {
          _this.player.play();
        }
      }, 500);

      //set position from last watch
      this.setStartPosition();
    },
    setStartPositionWhenSetUp() {
      let lastPosition = this.getLastPosition();
      //if last play is end then start from beginning
      if (lastPosition === parseInt(this.player.duration())) {
        lastPosition = 0;
      }

      this.player.currentTime(lastPosition);

      this.player.play();
    },
    setStartPosition() {
      let lastPosition = this.getLastPosition();

      //if last play is end then start from beginning
      if (lastPosition === parseInt(this.player.duration()) ||
        lastPosition >= parseInt(this.player.duration()) - 5) {
        lastPosition = 0;
      }

      this.player.on('loadedmetadata', function () {
        this.currentTime(lastPosition);
      });

    },
    getLastPosition(){
      let lastPosition = 0;

      //get last position from local storage
      lastPosition = localStorage.getItem(this.studentEnrollDetail.id + "-" + this.currentVdoSetTopic.id);
      if (!lastPosition) {
        lastPosition = 0
      }

      return parseInt(lastPosition);
    },
    saveLastPosition(currentTime) {
      localStorage.setItem(this.studentEnrollDetail.id + "-" + this.currentVdoSetTopic.id, currentTime)
    },
    //-------------------------- FOR UPDATE LEARN TIME --------------------------
    startTimer() {
      // console.log('startTimer', this.keepCounting)
      if(this.keepCounting){
        this.timer = setInterval(this.addCounter, 1000);
      }
    },
    stopTimer() {
      // console.log('stop timer');
      if (this.timer) {
        // console.log('exec countLearningPercent');
        this.countLearningPercent(this.counter);
        clearInterval(this.timer);
      }
    },
    async addCounter() {
      this.counter++;
      this.countLearningPercent(this.counter);
      if(this.counter > 10){
        this.counter = 0;
      }
    }
  },
  mounted() {
    if (!this.player) {
      this.setUpVideoJs();
    }
  },
  beforeDestroy() {
    this.stopTimer();
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss" type="text/css">
//@import '/video.js/dist/video-js.min.css';

.video-player {
  width: 100% !important;
  height: auto !important;
  max-height: calc(100vh - 180px) !important;
  background: #22292f;
  overflow: hidden;
  position: relative;

  & .video-js {
    width: 100% !important;
    height: auto !important;
    padding-top: 0 !important;

    & video {
      width: 100% !important;
      height: auto !important;
      max-height: 100vh;
      @media only screen and (min-height: 600px) {
        max-height: calc(100vh - 200px);
      }
    }

    & .vjs-control-bar {
      display: none;
      z-index: 999999;
      position: absolute;
    }

    & .vjs-loading-spinner {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      // background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      display: none;
    }

    & .vjs-big-play-button {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 200px;
      height: 200px;
      background: #0000005c;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      border-radius: 50%;
      border-width: 5px;
      border-color: #ffffff5e;
      display: none;
    }

    & .vjs-control-bar {
      display: none;
      position: absolute;
      bottom: 0;
      height: 40px;
      background: red;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      display: none;

      & > .vjs-control {
        margin: 10px;
      }

    }

    & .vjs-poster {
      display: none;
    }

    & .vjs-text-track-display {
      display: none;
    }

    & .vjs-error-display {
      display: none;
    }

    & .vjs-modal-dialog {
      display: none;
    }
  }
}
</style>
